/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/fi';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Käytä Pretty-tekstieditoria"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Helppokäyttöisyyden tarkistus"
  },
  "action_to_take_b626a99a": {
    "message": "Toimenpide, johon on ryhdyttävä:"
  },
  "add_8523c19b": {
    "message": "Lisää"
  },
  "add_a_caption_2a915239": {
    "message": "Lisää selitys"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Lisää alt-teksti kuvalle"
  },
  "add_another_f4e50d57": {
    "message": "Lisää toinen"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Lisää CC/alaotsikko"
  },
  "add_image_60b2de07": {
    "message": "Lisää kuva"
  },
  "add_one_9e34a6f8": {
    "message": "Lisää yksi!"
  },
  "additional_considerations_f3801683": {
    "message": "Muuta huomioon otettavaa"
  },
  "address_applied_64269b0b": {
    "message": "Osoite käytetty"
  },
  "address_removed_fcb496e0": {
    "message": "Osoite poistettu"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Sellaisten peräkkäisten linkkien, joilla on sama URL, pitäisi olla yksi linkki."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Tasaa"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Kohdistukset ja luettelot"
  },
  "all_4321c3a1": {
    "message": "Kaikki"
  },
  "all_apps_a50dea49": {
    "message": "Kaikki sovellukset"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Salli median lataus"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Salli transkription lataus"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Aakkosjärjestys"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Määritetekstissä ei saa olla yli 120 merkkiä."
  },
  "alt_text_611fb322": {
    "message": "Alt Text"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Sivutuote)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Virhe luettaessa tiedostoa"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Ilmeni virhe tehtäessä verkkopyyntöä"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Ilmeni virhe mediaasi ladatessa."
  },
  "and_7fcc2911": {
    "message": "Ja"
  },
  "angle_c5b4ec50": {
    "message": "Kulma"
  },
  "announcement_fb4cb645": {
    "message": "Ilmoitus"
  },
  "announcement_list_da155734": {
    "message": "Ilmoitusluettelo"
  },
  "announcements_a4b8ed4a": {
    "message": "Ilmoitukset"
  },
  "apply_781a2546": {
    "message": "Käytä"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Käytä muutoksia kaikkiin kurssin kuvakkeen tekijän kuvakkeen esiintymiin"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Saavuttaa rajan"
  },
  "approximately_e7965800": {
    "message": "Noin"
  },
  "apps_54d24a47": {
    "message": "Sovellukset"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Haluatko varmasti peruuttaa? Tekemiäsi muutoksia ei ehkä tallenneta."
  },
  "arrows_464a3e54": {
    "message": "Nuolet"
  },
  "art_icon_8e1daad": {
    "message": "Taide-kuvake"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Kuvasuhde säilytetään"
  },
  "assignment_976578a8": {
    "message": "Tehtävä"
  },
  "assignments_1e02582c": {
    "message": "Tehtävät"
  },
  "asterisk_82255584": {
    "message": "Tähtimerkki"
  },
  "attributes_963ba262": {
    "message": "Määritteet"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Ääni- ja videonauhoituksia ei tueta, valitse eri selain."
  },
  "audio_options_feb58e2c": {
    "message": "Äänivalinnat"
  },
  "audio_options_tray_33a90711": {
    "message": "Ääniasetusten ilmoitusalue"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Äänisoitin kohteelle { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Automaattisesti tallennettua sisältöä on olemassa. Haluaisitko ladata automaattisesti tallennetun sisällön tämän sijasta?"
  },
  "available_folders_694d0436": {
    "message": "Saatavissa olevat kansiot"
  },
  "background_1bc88842": {
    "message": "Tausta"
  },
  "backslash_b2d5442d": {
    "message": "Takakenoviiva"
  },
  "bar_ec63ed6": {
    "message": "tanko"
  },
  "basic_554cdc0a": {
    "message": "Perus"
  },
  "because_501841b": {
    "message": "Koska"
  },
  "below_81d4dceb": {
    "message": "Alle"
  },
  "beta_cb5f307e": {
    "message": "Beeta"
  },
  "big_circle_16b2e604": {
    "message": "Iso ympyrä"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomiaalinen kerroin"
  },
  "black_4cb01371": {
    "message": "Musta"
  },
  "blue_daf8fea9": {
    "message": "Sininen"
  },
  "bold_applied_42d547b7": {
    "message": "Lihavoitu käytetty"
  },
  "bold_removed_da474a5c": {
    "message": "Lihavoitu poistettu"
  },
  "border_5b08b06d": {
    "message": "Reunus"
  },
  "bottom_15a2a9be": {
    "message": "Ala"
  },
  "bottom_third_5f5fec1d": {
    "message": "Alakolmannes"
  },
  "bowtie_5f9629e4": {
    "message": "Rusetti"
  },
  "brick_f2656265": {
    "message": "Tiili"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Peruuta"
  },
  "cap_product_3a5265a6": {
    "message": "Korttituote"
  },
  "caption_manager_aae0906f": {
    "message": "Tekstityksen hallintatoiminto"
  },
  "center_align_e68d9997": {
    "message": "Keskuksen linjaus"
  },
  "centered_dot_64d5e378": {
    "message": "Keskitetty piste"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Keskitetyt vaakasuuntaiset pisteet"
  },
  "change_alt_text_92654906": {
    "message": "Vaihda alt-tekstiä"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Vaihda otsikkotunniste kappaleeseen"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Vaihda vain tämän otsikon taso"
  },
  "change_text_color_1aecb912": {
    "message": "Vaihda tekstin väriä"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Muutokset pysyvät voimassa, kun tallennat tämän sivun."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Tekemiäsi muutoksia ei ehkä tallenneta."
  },
  "characters_9d897d1c": {
    "message": "Merkit"
  },
  "characters_no_spaces_485e5367": {
    "message": "Merkkiä (ei välilyöntejä)"
  },
  "check_accessibility_3c78211c": {
    "message": "Tarkista käytettävyys"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Tarkistetaan käytettävyysongelmien varalta"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Muokkaa tekstitystiedostoa"
  },
  "choose_usage_rights_33683854": {
    "message": "Valitse käyttöoikeudet..."
  },
  "circle_484abe63": {
    "message": "Ympyrä"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "rengasta järjestämätön luettelo"
  },
  "clear_2084585f": {
    "message": "Tyhjennä"
  },
  "clear_image_3213fe62": {
    "message": "Tyhjennä kuva"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Napsauta ja valitse shift ja napsautus, niin saat html-editorin esiin."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Upota { imageName } napsauttamalla"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Piilota esikatselu napsauttamalla"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Lisää linkki editoriin napsauttamalla."
  },
  "click_to_show_preview_faa27051": {
    "message": "Näytä esikatselu napsauttamalla"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Sulje valikko tai valintaikkuna Palauttaa sinut myös editorialueelle"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Sulje käytettävyyden tarkistus"
  },
  "close_d634289d": {
    "message": "Sulje"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Sulje pikanäppäinikkuna"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Suljetun tekstitystiedoston täytyy olla alle { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Suljetut kuvatekstit/Tekstitykset"
  },
  "clubs_suit_c1ffedff": {
    "message": "Klubit (puku)"
  },
  "collab_575ac7bc": {
    "message": "Collab"
  },
  "collaborations_5c56c15f": {
    "message": "Yhteistyöt"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Piilota kutistamalla { types }"
  },
  "color_a363e1b0": {
    "message": "Väri"
  },
  "color_contrast_4c418add": {
    "message": "Värin kontrasti"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Värikontrastin suhde"
  },
  "color_picker_6b359edf": {
    "message": "Värivalitsin"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Värivalitsin ({ colorName } valittu)"
  },
  "color_popup_af39810f": {
    "message": "Värin ponnahdusvalikko"
  },
  "column_e1ae5c64": {
    "message": "Sarake"
  },
  "column_group_1c062368": {
    "message": "Sarakeryhmä"
  },
  "complex_numbers_a543d004": {
    "message": "Monimutkaiset numerot"
  },
  "computer_1d7dfa6f": {
    "message": "Tietokone"
  },
  "congruent_5a244acd": {
    "message": "Yhdenmukainen"
  },
  "contains_311f37b7": {
    "message": "Sisältää"
  },
  "content_1440204b": {
    "message": "Sisältö"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Sisältö muokkaustoiminnossa vaihdetaan Pidä alkuperäinen sisältö painamalla Peruuta."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Sisältöä ladataan yhä, jos jatkat, sitä ei upoteta kunnolla."
  },
  "content_subtype_5ce35e88": {
    "message": "Sisällön alityyppi"
  },
  "content_type_2cf90d95": {
    "message": "Sisältötyyppi"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Jatka YouTube-sisältöön"
  },
  "coproduct_e7838082": {
    "message": "Sivutuote"
  },
  "copyright_holder_66ee111": {
    "message": "Tekijänoikeuden haltija:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Sisällön lisääminen ei onnistunut: \"{ itemType }\" kohdetta ei tueta tällä hetkellä Canvasissa."
  },
  "count_40eced3b": {
    "message": "Määrä"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 sanaa}\n    one {1 sana}\n  other {# sanaa}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# kohdetta ladattu}\n  other {# kohteita ladattu}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Kurssiasiakirjat"
  },
  "course_files_62deb8f8": {
    "message": "Kurssitiedostot"
  },
  "course_files_a31f97fc": {
    "message": "Kurssitiedostot"
  },
  "course_images_f8511d04": {
    "message": "Kurssin kuvat"
  },
  "course_link_b369426": {
    "message": "Kurssilinkki"
  },
  "course_links_b56959b9": {
    "message": "Kurssin linkit"
  },
  "course_media_ec759ad": {
    "message": "Kurssimedia"
  },
  "course_navigation_dd035109": {
    "message": "Kurssin navigointi"
  },
  "create_icon_110d6463": {
    "message": "Luo kuvake"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Luo kuvakkeen tekijän kuvake"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons -lisenssi:"
  },
  "crop_image_41bf940c": {
    "message": "Rajaa kuva"
  },
  "crop_image_807ebb08": {
    "message": "Rajaa kuva"
  },
  "cup_product_14174434": {
    "message": "Korkkituote"
  },
  "current_image_f16c249c": {
    "message": "Nykyinen kuva"
  },
  "current_link_945a47ee": {
    "message": "Nykyinen linkki"
  },
  "current_volume_level_c55ab825": {
    "message": "Nykyinen äänenvoimakkuuden taso"
  },
  "custom_6979cd81": {
    "message": "Mukauta"
  },
  "cyan_c1d5f68a": {
    "message": "Syaani"
  },
  "dagger_57e0f4e5": {
    "message": "Tikari"
  },
  "date_added_ed5ad465": {
    "message": "Lisäyspäivämäärä"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Koristekuvake"
  },
  "decorative_image_fde98579": {
    "message": "Koristeellinen kuva"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Koriste { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Pienennä sisennystä"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Pienennä rikkaan sisällön aluetta"
  },
  "deep_purple_bb3e2907": {
    "message": "Tumman violetti"
  },
  "default_9db103d": {
    "message": "Oletus"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "luetelmakohdista koostuva järjestämätön oletuslista"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "numeerinen järjestetty oletuslista"
  },
  "definite_integral_fe7ffed1": {
    "message": "Ehdoton integraali"
  },
  "degree_symbol_4a823d5f": {
    "message": "Asteen symboli"
  },
  "delimiters_4db4840d": {
    "message": "Erottimet"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Kuvaa kuvake)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Kuvaa kohde { TYPE })"
  },
  "description_436c48d7": {
    "message": "Kuvaus"
  },
  "details_98a31b68": {
    "message": "Lisätiedot"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Piste"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamond"
  },
  "diamonds_suit_526abaaf": {
    "message": "Timantit (maa)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Ulottuvuuden tyyppi"
  },
  "directionality_26ae9e08": {
    "message": "Suuntaisuus"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Muokkaa LaTeX:iä suoraan"
  },
  "disable_preview_222bdf72": {
    "message": "Poista esikatselu käytöstä"
  },
  "discussion_6719c51d": {
    "message": "Keskustelu"
  },
  "discussions_a5f96392": {
    "message": "Keskustelut"
  },
  "discussions_index_6c36ced": {
    "message": "Keskustelujen indeksi"
  },
  "disjoint_union_e74351a8": {
    "message": "Erillinen liitto"
  },
  "display_options_315aba85": {
    "message": "Näytä vaihtoehdot"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Näytä tekstilinkki (avautuu uudessa välilehdessä)"
  },
  "div_applied_49ad83fc": {
    "message": "Div sovellettu"
  },
  "div_removed_d13f8e17": {
    "message": "Div poistettu"
  },
  "division_sign_72190870": {
    "message": "Jakomerkki"
  },
  "document_678cd7bf": {
    "message": "Asiakirja"
  },
  "documents_81393201": {
    "message": "Asiakirjat"
  },
  "done_54e3d4b6": {
    "message": "Valmis"
  },
  "double_dagger_faf78681": {
    "message": "Kaksinkertainen tikari"
  },
  "down_5831a426": {
    "message": "Alas"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonaalinen nuoli alas ja vasemmalle"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonaalinen nuoli alas ja oikealle"
  },
  "download_filename_2baae924": {
    "message": "Lataa { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Nuoli alaspäin"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Alaspäin osoittava kolmio"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Vedä tiedosto tähän"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Vedä ja pudota tai napsauta selataksesi tietokoneellasi"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Vedä kahva. Muuta kokoa ylä- ja alanuolilla"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Määräpäivä: Useita päivämääriä"
  },
  "due_when_7eed10c6": {
    "message": "Määräpäivä: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Muokkaa kaikki tekstit tälle kuvakkeen ilmentymälle"
  },
  "edit_c5fbea07": {
    "message": "Muokkaa"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Muokkaa kurssilinkkiä"
  },
  "edit_equation_f5279959": {
    "message": "Muokkaa kaavaa"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Muokkaa olemassa olevaa kuvakkeen tekijän kuvaketta"
  },
  "edit_icon_2c6b0e91": {
    "message": "Muokkaa kuvaketta"
  },
  "edit_link_7f53bebb": {
    "message": "Muokkaa linkkiä"
  },
  "editor_status_bar_653f44ee": {
    "message": "Editorin tilapalkki"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elementti, joka alkaa { start }"
  },
  "embed_828fac4a": {
    "message": "Upota"
  },
  "embed_code_314f1bd5": {
    "message": "Upota koodi"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Upota sisältöä ulkoisesta työkalusta"
  },
  "embed_image_1080badc": {
    "message": "Upota kuva"
  },
  "embed_video_a97a64af": {
    "message": "Upota video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "upotettu sisältö"
  },
  "empty_set_91a92df4": {
    "message": "Tyhjä joukko"
  },
  "encircled_dot_8f5e51c": {
    "message": "Ympyröity piste"
  },
  "encircled_minus_72745096": {
    "message": "Ympyröity miinus"
  },
  "encircled_plus_36d8d104": {
    "message": "Ympäröity plus"
  },
  "encircled_times_5700096d": {
    "message": "Ympäröidyt ajat"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Suunnittelu-kuvake"
  },
  "english_icon_25bfe845": {
    "message": "Englanninkielen kuvake"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Anna mediaotsikko"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Kirjoita vähintään 3 merkkiä ja tee haku"
  },
  "enter_replacement_text_17631bbc": {
    "message": "syötä korvaava teksti"
  },
  "enter_search_text_26cb4459": {
    "message": "syötä hakuteksti."
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (muuttuja)"
  },
  "equals_sign_c51bdc58": {
    "message": "Yhtä kuin -merkki"
  },
  "equation_1c5ac93c": {
    "message": "Yhtälö"
  },
  "equation_editor_39fbc3f1": {
    "message": "Yhtälöeditori"
  },
  "equilibrium_6ff3040b": {
    "message": "Tasapaino"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Vastaavuusluokka"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Vastaava (identiteetti)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "On olemassa"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Poistu koko näytöstä"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Laajenna esikatselu oletuksena"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Laajenna nähdäksesi { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Ulkoinen linkki"
  },
  "external_tool_frame_70b32473": {
    "message": "Ulkoinen työkalukehys"
  },
  "external_tools_6e77821": {
    "message": "Ulkoiset työkalut"
  },
  "extra_large_b6cdf1ff": {
    "message": "Erittäin suuri"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Erittäin suuri ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Erittäin pieni"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Kouluajan ulkopuolisen kohteen kuvake"
  },
  "f_function_fe422d65": {
    "message": "F (funktio)"
  },
  "fail_544e5dde": {
    "message": "VIKA"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Tiedoston sisällön haku epäonnistui"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Sisällön haku ulkoisesta työkalusta ei onnistunut"
  },
  "file_name_8fd421ff": {
    "message": "Tiedoston nimi"
  },
  "file_preview_21667a6e": {
    "message": "Tiedoston esikatselu"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Tiedoston esikatselukuva kohteelle { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Tiedoston tallennustilan kiintiö ylitetty"
  },
  "file_url_c12b64be": {
    "message": "Tiedoston URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } tiedostokuvake"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } kuvan esikatselu"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } tekstin esikatselu"
  },
  "files_c300e900": {
    "message": "Tiedostot"
  },
  "files_index_af7c662b": {
    "message": "Tiedostojen indeksi"
  },
  "find_8d605019": {
    "message": "Hae"
  },
  "find_and_replace_6e345933": {
    "message": "Etsi ja korvaa"
  },
  "finish_bc343002": {
    "message": "Lopeta"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Korjaa otsikon hierarkia"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (musiikki)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Tarkanne elementtien asetusten työkalupalkki"
  },
  "folder_tree_fbab0726": {
    "message": "Kansiopuu"
  },
  "for_all_b919f972": {
    "message": "Kaikille"
  },
  "format_4247a9c5": {
    "message": "Muotoile"
  },
  "format_as_a_list_142210c3": {
    "message": "Muotoile luettelona"
  },
  "formatting_5b143aa8": {
    "message": "Muotoillaan"
  },
  "forward_slash_3f90f35e": {
    "message": "Vinoviiva"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Löytyi automaattisesti tallennettua sisältöä"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Löytyi { count, plural,\n     =0 {# tulosta}\n    one {# tulos}\n  other {# tulosta}\n}"
  },
  "fraction_41bac7af": {
    "message": "Murto-osa"
  },
  "fullscreen_873bf53f": {
    "message": "Koko näyttö"
  },
  "gamma_1767928": {
    "message": "Gamma (gammakorjaus)"
  },
  "generating_preview_45b53be0": {
    "message": "Luodaan esikatselua..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Tällä hetkellä ei tueta GIF/PNG-muotoisia kuvia, jotka ovat suurempia kuin { size } KB."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Siirry editorin valikkopalkkiin"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Siirry editorin työkalupalkkiin"
  },
  "grades_a61eba0a": {
    "message": "Arvosanat"
  },
  "graphics_text_bc9568bc": {
    "message": "Graafinen teksti"
  },
  "greater_than_e98af662": {
    "message": "Suurempi kuin"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Suurempi tai yhtä suuri kuin"
  },
  "greek_65c5b3f7": {
    "message": "kreikka"
  },
  "green_15af4778": {
    "message": "Vihreä"
  },
  "grey_a55dceff": {
    "message": "Harmaa"
  },
  "group_documents_8bfd6ae6": {
    "message": "Ryhmän asiakirjat"
  },
  "group_files_4324f3df": {
    "message": "Ryhmän tiedostot"
  },
  "group_files_82e5dcdb": {
    "message": "Ryhmän tiedostot"
  },
  "group_images_98e0ac17": {
    "message": "Ryhmän kuvat"
  },
  "group_isomorphism_45b1458c": {
    "message": "Ryhmän isomorfismi"
  },
  "group_link_63e626b3": {
    "message": "Ryhmälinkki"
  },
  "group_links_9493129e": {
    "message": "Ryhmälinkit"
  },
  "group_media_2f3d128a": {
    "message": "Ryhmän media"
  },
  "group_navigation_99f191a": {
    "message": "Ryhmän navigointi"
  },
  "h_bar_bb94deae": {
    "message": "H bar"
  },
  "hat_ea321e35": {
    "message": "Hattu"
  },
  "header_column_f27433cb": {
    "message": "Otsikkosarake"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Otsikon rivi ja sarake"
  },
  "header_row_f33eb169": {
    "message": "Otsikkorivi"
  },
  "heading_2_5b84eed2": {
    "message": "Otsikko 2"
  },
  "heading_3_2c83de44": {
    "message": "Otsikko 3"
  },
  "heading_4_b2e74be7": {
    "message": "Otsikko 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Otsikko { h } sovelletaan"
  },
  "heading_h_removed_745f24a6": {
    "message": "Otsikko { h } poistettu"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Otsikon tasoja ei saa ohittaa."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Otsikot, jotka alkavat { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Otsikoissa voi olla korkeintaan 120 merkkiä."
  },
  "health_icon_8d292eb5": {
    "message": "Terveys-kuvake"
  },
  "hearts_suit_e50e04ca": {
    "message": "Sydämet (puku)"
  },
  "height_69b03e15": {
    "message": "Korkeus"
  },
  "hexagon_d8468e0d": {
    "message": "Kuusikulmio"
  },
  "hide_description_bfb5502e": {
    "message": "Piilota kuvaus"
  },
  "hide_title_description_caf092ef": {
    "message": "Piilota kohteen { title } kuvaus"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Korosta elementtejä aktivoidaksesi elmentin asetusten työkalupalkki"
  },
  "home_351838cd": {
    "message": "Aloitussivu"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Kuinka pyytää ja muokata tekstityksiä?"
  },
  "html_code_editor_fd967a44": {
    "message": "html-koodieditori"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-editori"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Olen hankkinut luvan käyttää tätä tiedostoa."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Minulla on tekijäoikeus"
  },
  "icon_215a1dc6": {
    "message": "Kuvake"
  },
  "icon_8168b2f8": {
    "message": "kuvake"
  },
  "icon_color_b86dd6d6": {
    "message": "Kuvakkeen väri"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Kuvakkeen tekijän kuvakkeet"
  },
  "icon_options_7e32746e": {
    "message": "Kuvakeasetukset"
  },
  "icon_options_tray_2b407977": {
    "message": "Kuvakkeiden ilmoitusalue"
  },
  "icon_preview_1782a1d9": {
    "message": "Kuvakkeen esikatselu"
  },
  "icon_shape_30b61e7": {
    "message": "Kuvakkeen muoto"
  },
  "icon_size_9353edea": {
    "message": "Kuvakkeen koko"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Jos jätit tyhjän kentän, teksti näkyy kurssilinkin nimenä"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Jos käyttöoikeudet vaaditaan, tiedostoa ei julkaista ennen kuin se otetaan käyttöön Tiedostot-sivulla."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Jos et valitse käyttöoikeuksia nyt, tiedoston julkaisu peruutetaan latauksen jälkeen."
  },
  "image_8ad06": {
    "message": "Kuva"
  },
  "image_c1c98202": {
    "message": "kuva"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Kuvan tiedostonimiä ei saa käyttää kuvan sisältöä kuvaavana alt-määritteenä."
  },
  "image_options_5412d02c": {
    "message": "Kuva-asetukset"
  },
  "image_options_tray_90a46006": {
    "message": "Kuva-asetusten ilmoitusalue"
  },
  "image_to_crop_3a34487d": {
    "message": "Rajattava kuva"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Kuva, jonka tiedostonimi on { file }"
  },
  "images_7ce26570": {
    "message": "Kuvat"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Kuvien pitäisi sisältää alt-määrite, joka kuvaa kuvan sisältöä-"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Kuvitteellinen osa (tai monimutkainen numero)"
  },
  "in_element_of_19ca2f33": {
    "message": "(/elementti)"
  },
  "increase_indent_6af90f7c": {
    "message": "Suurenna sisennystä"
  },
  "increase_rich_content_area_340b775": {
    "message": "Suurenna rikkaan sisällön aluetta"
  },
  "indefinite_integral_6623307e": {
    "message": "Epämääräinen integraali"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index }/{ max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Päättely"
  },
  "infinity_7a10f206": {
    "message": "ÄÄRETÖN"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Datan syöttökenttä"
  },
  "input_field_for_blue_561e020a": {
    "message": "Alphan syöttökenttä"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Vihreän syöttökenttä"
  },
  "input_field_for_red_86a84615": {
    "message": "Punaisen syöttökenttä"
  },
  "insert_593145ef": {
    "message": "Aseta"
  },
  "insert_link_6dc23cae": {
    "message": "Lisää linkki"
  },
  "insert_math_equation_57c6e767": {
    "message": "Lisää matemaattinen kaava"
  },
  "integers_336344e1": {
    "message": "Kokonaisluvut"
  },
  "intersection_cd4590e4": {
    "message": "Leikkauskohta"
  },
  "invalid_description_991e23bb": {
    "message": "Virheellinen kuvaus"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Väärä syöte."
  },
  "invalid_file_c11ba11": {
    "message": "Virheellinen tiedosto"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Virheellinen tiedostotyyppi"
  },
  "invalid_url_cbde79f": {
    "message": "Virheellinen URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Ongelma { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Kursiivia sovellettiin"
  },
  "italic_removed_17cbab6f": {
    "message": "Kursiivi poistettu"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (muuttuja)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Pikanäppäimet"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Näppäimistöt navigoivat linkkeihin Välilehti-painikkeen avulla. Kaksi peräkkäistä linkkiä, jotka ohjaavat samaan päämäärään, voivat olla hämmentäviä näppäimistön käyttäjille."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Kielen taiteiden kuvake"
  },
  "languages_icon_9d20539": {
    "message": "Kielien kuvake"
  },
  "large_9c5e80e7": {
    "message": "Suuri"
  },
  "large_text_e7ba08cd": {
    "message": "Suuri teksti"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Suuri ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Opi"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Lue lisää vierekkäisistä linkeistä"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Lue lisää värikontrastista"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Lue lisää sivuotsikoiden organisoimisesta"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Lue lisää asianmukaisesta sivuotsikoiden rakenteesta"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Lue lisää taulukon otsikoista"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Lue lisää vaihtoehtoisen tekstin käyttämisestä"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Lue lisää kuvatekstien käytöstä taulukoiden kanssa"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Lue lisää tiedostonimien käytöstä vaihtoehtoisessa tekstissä"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Lue lisää listojen käyttämisestä"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Lue lisää laajuuden määritteiden käytöstä taulukoiden kanssa"
  },
  "leave_as_is_4facfe55": {
    "message": "Jätä sellaiseksi kuin on"
  },
  "left_3ea9d375": {
    "message": "Vasen"
  },
  "left_align_43d95491": {
    "message": "Vasen linjaus"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Vasen kulmakiinnike"
  },
  "left_arrow_4fde1a64": {
    "message": "Nuoli vasemmalle"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Vasen nuoli koukulla"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Vasen katto"
  },
  "left_curly_brace_1726fb4": {
    "message": "Vasen aaltosulku"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Vasen alaspäin suuntaava harppuunanuoli"
  },
  "left_floor_29ac2274": {
    "message": "Vasen kerros"
  },
  "left_to_right_e9b4fd06": {
    "message": "Vasemmalta-Oikealle"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Vasen ylöspäin suuntaava harppuunanuoli"
  },
  "leftward_arrow_1e4765de": {
    "message": "Nuoli vasemmalle"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Vasemmalle osoittava kolmio"
  },
  "less_than_a26c0641": {
    "message": "Vähemmän kuin"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Vähemmän tai yhtä suuri kuin"
  },
  "library_icon_ae1e54cf": {
    "message": "Kirjaston kuvake"
  },
  "light_blue_5374f600": {
    "message": "Vaaleansininen"
  },
  "link_7262adec": {
    "message": "Linkki"
  },
  "link_options_a16b758b": {
    "message": "Linkin asetukset"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "linkin tyyppi: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Linkki tekstillä, joka alkaa { start }"
  },
  "links_14b70841": {
    "message": "Linkit"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Linkittyy ulkoiselle sivustolle."
  },
  "lists_cd1336fc": {
    "message": "Listat"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Luettelot pitäisi muotoilla luetteloina."
  },
  "load_more_35d33c7": {
    "message": "Lataa lisää"
  },
  "loading_25990131": {
    "message": "Ladataan..."
  },
  "loading_bde52856": {
    "message": "Ladataan"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "suljettujen tekstitysten lataus epäonnistui."
  },
  "loading_external_tool_d839042c": {
    "message": "Ladataan ulkoista työkalua"
  },
  "loading_failed_b3524381": {
    "message": "Lataus epäonnistui..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Lataus epäonnistui."
  },
  "loading_folders_d8b5869e": {
    "message": "Ladataan kansioita"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Ladataan paikkamerkkejä kohteelle { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Ladataan, odota"
  },
  "loading_preview_9f077aa1": {
    "message": "Esikatselua ladataan"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Lukitse nopeus 1x"
  },
  "locked_762f138b": {
    "message": "Lukittu"
  },
  "logical_equivalence_76fca396": {
    "message": "Looginen vastaavuus"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Looginen vastaavuus (lyhyt)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Looginen vastaavuus (lyhyt ja paksu)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Looginen vastaavuus (paksu)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Matalat vaakasuuntaiset pisteet"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Kartoita kohteeseen"
  },
  "math_icon_ad4e9d03": {
    "message": "Matematiikan kuvake"
  },
  "media_af190855": {
    "message": "Tietoväline"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Yritä myöhemmin uudelleen. Yritä myöhemmin uudelleen."
  },
  "media_options_saved_560c4ec8": {
    "message": "Laitteiden tallennus onnistui."
  },
  "media_title_2112243b": {
    "message": "Median otsikko"
  },
  "medium_5a8e9ead": {
    "message": "Tietoväline"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Keskikokoinen ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Yhdistä linkkejä"
  },
  "mic_a7f3d311": {
    "message": "Mikrofoni"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofoni pois käytöstä"
  },
  "middle_27dc1d5": {
    "message": "Kohtalainen"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimoi tiedoston esikatselu"
  },
  "minimize_video_20aa554b": {
    "message": "Minimoi video"
  },
  "minus_fd961e2e": {
    "message": "Miinus"
  },
  "minus_plus_3461f637": {
    "message": "Miinus/plus"
  },
  "misc_3b692ea7": {
    "message": "Sekalainen"
  },
  "miscellaneous_e9818229": {
    "message": "Muut asiat"
  },
  "module_90d9fd32": {
    "message": "Moduuli"
  },
  "modules_c4325335": {
    "message": "Moduulit"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Siirretään kuvaa kohteen { directionWord } rajaamiseksi"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Monivärinen kuva"
  },
  "multiplication_sign_15f95c22": {
    "message": "Kertomerkki"
  },
  "music_icon_4db5c972": {
    "message": "Musiikki-kuvake"
  },
  "my_files_2f621040": {
    "message": "Omat tiedostot"
  },
  "n_th_root_9991a6e4": {
    "message": "N-th-juuri"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nimi"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Luonnollinen (musiikki)"
  },
  "natural_numbers_3da07060": {
    "message": "Luonnollliset numerot"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Siirry valikon tai työkalupalkin läpi"
  },
  "navigation_ee9af92d": {
    "message": "Navigaatio"
  },
  "nested_greater_than_d852e60d": {
    "message": "on suurempi kuin"
  },
  "nested_less_than_27d17e58": {
    "message": "on pienempi kuin"
  },
  "new_quiz_34aacba6": {
    "message": "Uusi testi"
  },
  "next_40e12421": {
    "message": "Seuraava"
  },
  "next_findtext_9d69f0fe": {
    "message": "Seuraava { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Ei havaittu käytettävyysongelmia."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Ilmoituksia ei ole vielä luotu."
  },
  "no_announcements_found_20185afc": {
    "message": "Ilmoituksia ei löytynyt."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Tehtäviä ei ole vielä luotu."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Tehtäviä ei löytynyt."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Ei tallennettavia muutoksia."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Keskusteluja ei ole vielä luotu."
  },
  "no_discussions_found_9284063b": {
    "message": "Keskusteluja ei löytynyt."
  },
  "no_e16d9132": {
    "message": "Ei"
  },
  "no_file_chosen_9a880793": {
    "message": "Ei valittua tiedostoa"
  },
  "no_headers_9bc7dc7f": {
    "message": "Ei otsikoita"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Moduuleja ei ole vielä luotu."
  },
  "no_modules_found_2df43a40": {
    "message": "Moduuleja ei löytynyt."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Sivuja ei ole vielä luotu"
  },
  "no_pages_found_6799350": {
    "message": "Sivuja ei löytynyt."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Tälle tiedostolle ei ole saatavissa esikatselua."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Testejä ei ole vielä luotu."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Testejä ei löytynyt."
  },
  "no_results_940393cf": {
    "message": "Ei tuloksia."
  },
  "no_results_found_58717065": {
    "message": "Tuloksia ei löytynyt"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Tuloksia ei löytynyt kohteelle { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ei videota"
  },
  "none_3b5e34d2": {
    "message": "Ei mitään"
  },
  "none_selected_b93d56d2": {
    "message": "Ei valintoja"
  },
  "normal_text_7b03da48": {
    "message": "Normaali teksti"
  },
  "not_equal_6e2980e6": {
    "message": "Ei yhtä suuri"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ei (vain tämän elementti)"
  },
  "not_negation_1418ebb8": {
    "message": "Ei (kielto)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ei osajoukkoa"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ei osajoukko (tiukka)"
  },
  "not_superset_5556b913": {
    "message": "Ei superjoukkoa"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ei superjoukkoa (tiukka)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Kahdeksankulmio"
  },
  "olive_6a3e4d6b": {
    "message": "Oliivi"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Yksi seuraavista tyyleistä täytyy lisätä, jotta kuvake voidaan tallentaa: Kuvakkeen väri, ääriviivan koko, kuvakkeen teksti tai kuva"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Yhtä tai useampaa tiedostoa ei lisätty. Yritä ladata tai vetää ja pudottaa tiedostoja."
  },
  "open_circle_e9bd069": {
    "message": "Avoin ympyrä"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Avaa tämä näppäimistön pikakuvakkeiden valintaruutu"
  },
  "open_title_application_fd624fc5": {
    "message": "Avoin { title }-sovellus"
  },
  "operators_a2ef9a93": {
    "message": "Operaattorit"
  },
  "options_3ab0ea65": {
    "message": "Asetukset"
  },
  "or_9b70ccaa": {
    "message": "Tai"
  },
  "orange_81386a62": {
    "message": "Oranssi"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Järjestetyt ja järjestämättömät listat"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Muu editorin pikakuvakkeet löytyvät"
  },
  "outline_color_3ef2cea7": {
    "message": "Ääriviivan väri"
  },
  "outline_size_a6059a21": {
    "message": "Ääriviivan koko"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ei ole voimassa oleva protokolla."
  },
  "page_50c4823d": {
    "message": "Sivu"
  },
  "pages_e5414c2c": {
    "message": "Sivut"
  },
  "paragraph_5e5ad8eb": {
    "message": "Kappale"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Kappaletta sovellettiin"
  },
  "paragraph_removed_d09320e": {
    "message": "Kappale poistettiin"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Kappale, joka alkaa { start }"
  },
  "parallel_d55d6e38": {
    "message": "Rungon suuntainen"
  },
  "partial_derivative_4a9159df": {
    "message": "Osittainen (johdannainen)"
  },
  "pass_1c19a2b3": {
    "message": "LÄPÄISTY"
  },
  "paste_5963d1c1": {
    "message": "Liitä"
  },
  "pause_12af3bb4": {
    "message": "Keskeytä"
  },
  "pentagon_17d82ea3": {
    "message": "Viisikulmio"
  },
  "people_b4ebb13c": {
    "message": "Henkilöt"
  },
  "percentage_34ab7c2c": {
    "message": "Prosenttimäärä"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Prosenttiosuuden täytyy olla numero"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Prosenttiosuuden täytyy olla vähintään { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Esittävien taiteiden kuvake"
  },
  "perpendicular_7c48ede4": {
    "message": "Kohtisuora"
  },
  "phi_4ac33b6d": {
    "message": "Pii"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Pii (muuttuja)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Liikuntakasvatuksen kuvake"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Muuttuja)"
  },
  "pick_a_color_557abfb0": {
    "message": "Valitse väri"
  },
  "pink_68ad45cb": {
    "message": "Vaaleanpunainen"
  },
  "pixels_52ece7d1": {
    "message": "Pikselit"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pikseleiden täytyy olla vähintään { width } x { height }px."
  },
  "play_1a47eaa7": {
    "message": "Toista"
  },
  "play_media_comment_35257210": {
    "message": "Toista mediakommentti."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Toista mediakommentti { name } kohteesta { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Player-asettelu"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Anna Canvasin käyttää mikrofoniasi ja nettikameraasi."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Ole hyvä ja valitse tiedosto"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Ole hyvä ja syötä tiedosto nimi"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Syötä kelvollinen videon URL tuetulta alustalta."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Valitse tuettavan tyypin tiedosto"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/miinus"
  },
  "posted_when_a578f5ab": {
    "message": "Lähetetty: { when }"
  },
  "power_set_4f26f316": {
    "message": "Voimajoukko"
  },
  "precedes_196b9aef": {
    "message": "Edeltää"
  },
  "precedes_equal_20701e84": {
    "message": "Edeltää yhtä suurta"
  },
  "preformatted_d0670862": {
    "message": "Esimuotoiltu"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Edellinen"
  },
  "preview_53003fd2": {
    "message": "Esikatsele"
  },
  "preview_a3f8f854": {
    "message": "ESIKATSELU"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Esikatselu asettelussa"
  },
  "preview_inline_9787330": {
    "message": "Esikatselu inline-tilassa"
  },
  "previous_bd2ac015": {
    "message": "Edellinen"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Edellinen { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Aikaisemmin valitut värit"
  },
  "prime_917ea60e": {
    "message": "Alku"
  },
  "prime_numbers_13464f61": {
    "message": "Alkuluvut"
  },
  "product_39cf144f": {
    "message": "Tuote"
  },
  "proportional_f02800cc": {
    "message": "Suhteellinen"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokollan täytyy olla ftp, http, https, mailto, skype, tel tai se saatetaan poistaa"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "julkaistu"
  },
  "published_when_302d8e23": {
    "message": "Julkaistu: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Kurpitsa"
  },
  "purple_7678a9fc": {
    "message": "Violetti"
  },
  "quaternions_877024e0": {
    "message": "Kvaterniot"
  },
  "quiz_e0dcce8f": {
    "message": "Tietovisa"
  },
  "quizzes_7e598f57": {
    "message": "Tietovisat"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rationaaliset luvut"
  },
  "real_numbers_7c99df94": {
    "message": "Oikeat numerot"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Todellinen osa (kompleksinumerosta)"
  },
  "record_7c9448b": {
    "message": "Nauhoita"
  },
  "record_upload_media_5fdce166": {
    "message": "Nauhoita/lataa mediaa"
  },
  "recording_98da6bda": {
    "message": "Nauhoitetaan"
  },
  "red_8258edf3": {
    "message": "Punainen"
  },
  "relationships_6602af70": {
    "message": "Suhteet"
  },
  "religion_icon_246e0be1": {
    "message": "Uskonnon kuvake"
  },
  "remove_f47dc62a": {
    "message": "Poista"
  },
  "remove_filename_3ea029f6": {
    "message": "Poista { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Poista otsikkotyyli"
  },
  "remove_link_d1f2f4d0": {
    "message": "Poista linkki"
  },
  "replace_all_d3d68b3": {
    "message": "Korvaa kaikki"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Korvaa kaikki { findText } kohteella { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Korvaa"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Korvaa kohde { findText } kohteella { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Korvaa tällä"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Kohde { alertFindText } korvattu kohteella { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Kaikki kohteetl { alertFindText } korvattu kohteella { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Nollaa"
  },
  "resize_ec83d538": {
    "message": "Muuta kokoa"
  },
  "restore_auto_save_deccd84b": {
    "message": "Palautetetaanko automaattinen tallennus?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Tulos { index } / { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Kääntöportti (ei anna periksi)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (muuttuja)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rikas sisältöeditori"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Monipuolisen tekstieditorin sisältökenttä Paina { OSKey }+F8, jos haluat nähdä tekstimuotoilueditorin pikakuvakkeita."
  },
  "right_71ffdc4d": {
    "message": "Oikea"
  },
  "right_align_39e7a32a": {
    "message": "Oikea linjaus"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Oikea kulmakiinnike"
  },
  "right_arrow_35e0eddf": {
    "message": "Nuoli oikealle"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Oikea nuoli koukulla"
  },
  "right_ceiling_839dc744": {
    "message": "Oikea katto"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Oikea aaltosulku"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Oikea alaspäin suuntaava harppuunanuoli"
  },
  "right_floor_5392d5cf": {
    "message": "Oikea kerros"
  },
  "right_to_left_9cfb092a": {
    "message": "Oikealta-Vasemmalle"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Oikea ylöspäin suuntaava harppuunanuoli"
  },
  "rightward_arrow_32932107": {
    "message": "Oikea ylöspäin suuntaava nuoli"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Oikealle osoittava kolmio"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Käännä kuvaa -90 astetta"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Käännä kuvaa 90 astetta"
  },
  "rotation_9699c538": {
    "message": "Pyöriminen"
  },
  "row_fc0944a7": {
    "message": "Rivi"
  },
  "row_group_979f5528": {
    "message": "Rivin ryhmä"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Harmi, mutta Pretty-tekstieditoria ei voi käyttää näppäimistöltä. Käytä HTML-tekstieditoria täällä."
  },
  "save_11a80ec3": {
    "message": "Tallenna"
  },
  "save_copy_ca63944e": {
    "message": "Tallenna kopio"
  },
  "save_media_cb9e786e": {
    "message": "Tallenna media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Tallennetut kuvakkeen tekijän kuvakkeet"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Näytönlukijat eivät voi määrittää, mikä näkyy kuvassa ilman vaihtoehtoista tekstiä, ja tiedostonimet ovat usein tarkoituksettomia numeroiden ja kirjaiminen merkkijonoja, jotka eivät kuvaa kontekstia tai tarkoitusta."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Näytönlukijat eivät voi määrittää, mitä kuvassa näkyy ilman vaihtoehtoista tekstiä, joka kuvaa kuvan sisällön ja tarkoituksen. Vaihtoehtoisen tekstin pitäisi olla yksinkertainen ja tiivis."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Näytönlukijat eivät voi määrittää, mitä kuvassa näkyy ilman vaihtoehtoista tekstiä, joka kuvaa kuvan sisällön ja tarkoituksen."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Näytönlukijat eivät voi tulkita taulukoita ilman asianmukaista rakennetta. Taulukon otsikot tarjoavat suunnan ja sisältöalueen."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Näytönlukijat eivät voi tulkita taulukoita ilman asianmukaista rakennetta. Taulukon tekstit kuvaavat kontekstin ja taulukon yleisen ymmärryksen."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Näytönlukijat eivät voi tulkita taulukoita ilman asianmukaista rakennetta. Taulukon otsikot tarjoavat sisällön suunnan ja yleiskatsauksen."
  },
  "script_l_42a7b254": {
    "message": "Merkkijono L"
  },
  "search_280d00bd": {
    "message": "Hae"
  },
  "select_audio_source_21043cd5": {
    "message": "Valitse äänilähde"
  },
  "select_crop_shape_d441feeb": {
    "message": "Valitse rajauksen muoto"
  },
  "select_language_7c93a900": {
    "message": "Valitse kieli"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Valitse videolähde"
  },
  "selected_274ce24f": {
    "message": "Valittu"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Valittu { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Valinta"
  },
  "set_header_scope_8c548f40": {
    "message": "Määritä otsikon ala"
  },
  "set_minus_b46e9b88": {
    "message": "Aseta miinus"
  },
  "set_table_header_cfab13a0": {
    "message": "Määritä taulukon otsikko"
  },
  "sharp_music_ab956814": {
    "message": "Terävä (musiikki)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Nuolet"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O avaa Pretty-tekstieditorin."
  },
  "shortcut_911d6255": {
    "message": "Oikotie"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Näytä kuva-asetukset"
  },
  "show_link_options_545338fd": {
    "message": "Näytä linkin asetukset"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Näytä vierivä transkriptio"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Näytä vierivä transkriptio"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Näkevät käyttäjät selaavat verkkosivustoja nopeasti ja etsivät suuria tai lihavoituja otsikoita. Näytönlukijan käyttäjät nojaavat otsikkoihin ymmärtääkseen kontekstuaalisesti. Otsikoita pitäisi käyttää asianmukaisen rakenteen luomiseksi."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Näkevät käyttäjät selaavat verkkosivustoja nopeasti ja etsivät suuria tai lihavoituja otsikoita. Näytönlukijan käyttäjät nojaavat otsikkoihin ymmärtääkseen kontekstuaalisesti. Otsikoiden pitäisi olla tiiviitä ja asianmukaisessa rakenteessa."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (muuttuja)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Yksivärinen kuva"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Yksivärinen kuvan väri"
  },
  "size_b30e1077": {
    "message": "Koko"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Tekstitystiedosto on kooltaan suurempi kuin suurin sallittu tiedostokoko { max } kb."
  },
  "small_b070434a": {
    "message": "Pieni"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Pieni ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Kiinteä ympyrä"
  },
  "something_went_wrong_89195131": {
    "message": "Jotakin meni pieleen."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Jotakin meni pieleen, kun yritettiin käyttää verkkokameraa."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Jotakin meni pieleen enkä tiedä, mitä näyttää sinulle,"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Jotakin meni pieleen. Tarkista yhteytesi, lataa sivu uudelleen ja yritä uudelleen."
  },
  "something_went_wrong_d238c551": {
    "message": "Jotakin meni pieleen."
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Jokin meni pieleen näyttösi jakamisen yhteydessä."
  },
  "sort_by_e75f9e3e": {
    "message": "Lajitteluperuste"
  },
  "spades_suit_b37020c2": {
    "message": "Pata (suit)"
  },
  "square_511eb3b3": {
    "message": "Neliö"
  },
  "square_cap_9ec88646": {
    "message": "Nelikantasuojus"
  },
  "square_cup_b0665113": {
    "message": "Nelikantasuojus"
  },
  "square_root_e8bcbc60": {
    "message": "Neliöjuuri"
  },
  "square_root_symbol_d0898a53": {
    "message": "Neliöjuuren symboli"
  },
  "square_subset_17be67cb": {
    "message": "Neliöosajoukko"
  },
  "square_subset_strict_7044e84f": {
    "message": "Neliöosajoukko (tiukka)"
  },
  "square_superset_3be8dae1": {
    "message": "Neliöosajoukko"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Neliöosajoukko (tiukka)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "järjestä järjestämätön luettelo"
  },
  "star_8d156e09": {
    "message": "Tähti"
  },
  "start_over_f7552aa9": {
    "message": "Aloita alusta"
  },
  "start_recording_9a65141a": {
    "message": "Aloita nauhoitus"
  },
  "steel_blue_14296f08": {
    "message": "Teräksensininen"
  },
  "studio_media_options_ee504361": {
    "message": "Studion mediaväline"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studion mediavälinealue"
  },
  "styles_2aa721ef": {
    "message": "Tyylit"
  },
  "submit_a3cc6859": {
    "message": "Lähetä"
  },
  "submitting_b90fac62": {
    "message": "Lähetetään..."
  },
  "subscript_59744f96": {
    "message": "Alaindeksi"
  },
  "subset_19c1a92f": {
    "message": "Osajoukko"
  },
  "subset_strict_8d8948d6": {
    "message": "Osajoukko (tiukka)"
  },
  "succeeds_9cc31be9": {
    "message": "Onnistuu"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Onnistuu yhtä hyvin"
  },
  "sum_b0842d31": {
    "message": "Summa"
  },
  "superscript_8cb349a2": {
    "message": "Yläindeksi"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Ylä- ja alaindeksi"
  },
  "superset_c4db8a7a": {
    "message": "Osajoukko"
  },
  "superset_strict_c77dd6d2": {
    "message": "Osajoukko (tiukka)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Tuetut tiedostotyypit: SRT tai WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Vaihda Pretty HTLM -tekstieditoriin"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Vaihda HTML-raakatekstieditoriin"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Vaihda tekstieditoriin"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Vaihda tekstimuotoilueditoriin"
  },
  "syllabus_f191f65b": {
    "message": "Opinto-ohjelma"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Järjestelmän audio sallittu"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Järjestelmän audio pois käytöstä"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Nuolet"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Taulukon otsikko, joka alkaa { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Taulukko, joka alkaa { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Taulukon otsikoiden pitäisi määrittää ala."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Taulukoiden pitäisi sisältää selitys, joka kuvaa taulukon sisältöä."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Taulukkojen pitäisi sisältää vähintään yksi otsikko."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Sinivihreä"
  },
  "text_7f4593da": {
    "message": "Teksti"
  },
  "text_background_color_16e61c3f": {
    "message": "Tekstin taustaväri"
  },
  "text_color_acf75eb6": {
    "message": "Tekstiväri"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Teksti on vaikea lukea erityisesti huononäköisille, jos tekstin ja tausta välillä ei ole riittävää kontrastia."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "18pt:n (tai lihavoitu 14pt) kokoista tekstiä suurempi teksti pitäisi näyttää vähintään kontrastitasolla 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Teksti (valinnainen)"
  },
  "text_position_8df8c162": {
    "message": "Tekstin paikka"
  },
  "text_size_887c2f6": {
    "message": "Tekstikoko"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "18pt:n (tai lihavoitu 14pt) kokoista tekstiä pitäisi näyttää vähintään kontrastitasolla 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Asiakirjan esikatselua käsitellään parhaillaan. Yritä myöhemmin uudelleen."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Ensimmäisen otsikon sivulla pitäisi olla H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Rikkaan sisällön alueen korkeutta pienennetään."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Rikkaan sisällön alueen korkeutta suurennetaan."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materiaali on vapaasti käytössä (public domain)."
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materiaali on lisensoitu Creative Commons -lisenssillä"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Materiaali on poikkeuksen (esim. Fair Use, oikeus lainata tai muiden sovellettavien tekijänoikeuslakien) alainen"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Harmi, mutta Pretty-tekstieditoria ei voi käyttää näppäimistöltä. Kun painat Shift-O, tekstieditori avautuu."
  },
  "therefore_d860e024": {
    "message": "Tästä syystä"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (muuttuja)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Paksu alaspäin suuntaava nuoli"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Paksu vasemmalle suuntaava nuoli"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Paksu nuoli vasemmalle"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Paksu nuoli oikealle"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Paksu oikealle suuntaava nuoli"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Paksu ylöspäin suuntaava nuoli"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Tätä asiakirjaa ei voi näyttää Canvasissa."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Tätä kaavaa ei voida hahmontaa perusnäkymässä."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Tämä kuva ei ole tällä hetkellä saatavissa"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Tämä video saattaa näyttää YouTube-mainoksia."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Vaikka videollasi on oikea otsikko selaimessa, sen päivitys tietokannassa epäonnistui."
  },
  "thumbnail_e0de666f": {
    "message": "Pienoiskuva"
  },
  "timebar_a4d18443": {
    "message": "Aikapalkki"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Otsikko ei voi olla tyhjä"
  },
  "title_ee03d132": {
    "message": "Otsikko"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Lähetetään: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Tehtävä: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Vaihda { summary } ryhmää"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Vaihtele työkaluvihjettä"
  },
  "tools_2fcf772e": {
    "message": "Työkalut"
  },
  "top_66e0adb6": {
    "message": "Yläosa"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Transkriptiopaneeli on käytettävissä yli 720 px:n leveyksillä."
  },
  "tray_839df38a": {
    "message": "Alusta"
  },
  "triangle_6072304e": {
    "message": "Kolmio"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Kääntöportti (tuotto)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "käytä kuvan asetuksia kirjoittamalla Control F9. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "käytä musteen asetuksia kirjoittamalla Control F9. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "käytä taulukon asetuksia kirjoittamalla Control F9. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Resurssin valinnan url-linkin määrittäminen ei onnistu"
  },
  "underline_applied_ae01ec97": {
    "message": "Allekirjoitusta sovellettiin"
  },
  "underline_removed_3693e17c": {
    "message": "Allekirjoitus poistettu"
  },
  "union_e6b57a53": {
    "message": "Liitto"
  },
  "unpublished_dfd8801": {
    "message": "julkaisematon"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Kaikki muutokset menetetään."
  },
  "untitled_16aa4f2b": {
    "message": "Nimetön"
  },
  "untitled_efdc2d7d": {
    "message": "Nimetön"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonaalinen nuoli ylös ja vasemmalle"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonaalinen nuoli ylös ja oikealle"
  },
  "up_c553575d": {
    "message": "Ylös"
  },
  "updated_link_a827e441": {
    "message": "Päivitetty linkki"
  },
  "upload_document_253f0478": {
    "message": "Lataa asiakirja"
  },
  "upload_file_fd2361b8": {
    "message": "Lataa tiedosto"
  },
  "upload_image_6120b609": {
    "message": "Lisää kuva"
  },
  "upload_media_ce31135a": {
    "message": "Lataa mediaa"
  },
  "upload_record_media_e4207d72": {
    "message": "Lataa/Tallennusväline"
  },
  "uploading_19e8a4e7": {
    "message": "Ladataan"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "aakkosellinen järjestetty isojen kirjainten lista"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi iso kirjain"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi iso kirjain"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "järjestetty roomalaisten numeroiden lista"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma iso kirjain"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta iso kirjain"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon iso kirjain"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi iso kirjain"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Ylös- ja alaspäin osoittava nuoli"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Ylös- ja alaspäin osoittava nuoli (paksu)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Nuoli ylöspäin"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Ylöspäin osoittava kolmio"
  },
  "url_22a5f3b8": {
    "message": "URL-osoite"
  },
  "usage_right_ff96f3e2": {
    "message": "Käyttöoikeus:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Käyttöoikeudet (vaaditaan)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Siirry vaihtoehdoissa nuolinäppäinten avulla."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Valitse nuolipainikkeet valitaksesi muodon."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Valitse nuolipainikkeet valitaksesi koon."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Valitse nuolipainikkeet valitaksesi tekstin paikan."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Valitse nuolipainikkeet valitaksesi tekstin koon."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Valitse nuolipainikkeet ääriviivan koon."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Näytönlukijat käyttävät kuvaamaan kohteen { TYPE } sisältöä"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Näytönlukijat käyttävät kuvaamaan kuvan sisältöä"
  },
  "user_documents_c206e61f": {
    "message": "Käyttäjän asiakirjat"
  },
  "user_files_78e21703": {
    "message": "Käyttäjätiedostot"
  },
  "user_images_b6490852": {
    "message": "Käyttäjän kuvat"
  },
  "user_media_14fbf656": {
    "message": "Käyttäjän tietoväline"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektori (merkintä)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Pystypalkki (Määritä rakentajan huomatukset)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Pystysuorat pisteet"
  },
  "video_options_24ef6e5d": {
    "message": "Videoasetukset"
  },
  "video_options_tray_3b9809a5": {
    "message": "Videoasetusten ilmoitusalue"
  },
  "video_player_b371005": {
    "message": "Videosoitin"
  },
  "video_player_for_9e7d373b": {
    "message": "Videonauhuri kohteelle "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Videonauhuri kohteelle { title }"
  },
  "video_url_889d3263": {
    "message": "Videon URL"
  },
  "view_all_e13bf0a6": {
    "message": "Näytä kaikki"
  },
  "view_ba339f93": {
    "message": "Tarkastele"
  },
  "view_description_30446afc": {
    "message": "Näytä kuvaus"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Näytä näppäimistön pikakuvakkeet"
  },
  "view_title_description_67940918": {
    "message": "Näytä kohteen { title } kuvaus"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Tarkastele sanamäärää ja merkkien määrää"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Katselurajoitukset"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Emme havainneet toimivaa mikrofonia, joka olisi kytkettynä puhelimeen."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Emme havainneet verkkokameraa, joka olisi kytkettynä puhelimeen."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Emme havainneet toimivaa verkkokameraa tai mikrofonia, jotka olisivat kytkettynä laitteeseesi."
  },
  "webcam_disabled_30c66986": {
    "message": "Webkamera pois käytöstä"
  },
  "webcam_fe91b20f": {
    "message": "Nettikamera"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Verkkosivustoilla pitäisi olla vain yksi H1, jota käytetään automaattisesti sivun otsikkona. Ensimmäisen otsikon sisällössäsi pitäisi olla H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Kun käytetään merkintää, joka visuaalisesti muotoilee kohteet luettelona, mutta ei ilmaise suhdetta, käyttäjillä saattaa olla vaikeuksia tietojen navigoinnissa."
  },
  "white_87fa64fd": {
    "message": "Valkoinen"
  },
  "why_523b3d8c": {
    "message": "Miksi..."
  },
  "width_492fec76": {
    "message": "Leveys"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Leveyden ja korkeuden täytyy olla numeroita"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Home"
  },
  "word_count_c77fe3a6": {
    "message": "Sanamäärä"
  },
  "words_b448b7d5": {
    "message": "Sanat"
  },
  "wreath_product_200b38ef": {
    "message": "Seppeletuote"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Kyllä"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Olet väripaletissa. Jos haluat navigoida palettia ylös, vasermmalle, alas tai oikealle, käytä painikkeita ”W”, ”A”, ”S” ja ”D” vastaavassa järjestyksessä."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Olet väriliu´ittimessa. Jos haluat siirtyä vasemmalle tai oikealle, käytä painikkeita ”A” ja ”D” vastaavassa järjestyksessä."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Olet alphaliu´ittimessa. Jos haluat siirtyä vasemmalle tai oikealle, käytä painikkeita ”A” ja ”D” vastaavassa järjestyksessä."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Kuvakkeen tekijän ilmoitusalueella on tallentamattomia muutoksia. Haluatko jatkaa tallentamatta näitä muutoksia?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Sinun täytyy ehkä säätää lisäotsikoita, jotta voit ylläpitää sivuhierarkian."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Et voi ladata tyhjää tiedostoa."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Kuvasi on pakattu Icon Makeria varten. Alle { size } KB:n kokoisia kuvia ei pakata."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofonisi on estetty selainasetuksissa."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Mikrofonisi ja verkkokamerasi on lukittu selainasetuksissa."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Verkkokamerasi lukitaan selainasetuksissa."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Nettikamerasi saattaa olla jo käytössä."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube upotus-URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoomaa"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Lähennä kuvaan"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Loitonna kuvasta"
  }
};
formatMessage.addLocale({
  fi: locale
});